import React from "react";
import STI from "./STI";
import VPD1 from "./VPD1";
import VPD2 from "./VPD2";
import WBD from "./WBD";
import OTH1 from "./OTH1";
import OTH2 from "./OTH2";
import HMG from "./HMG";
import FBD from "./FBD";
import { Routes, Route } from "react-router-dom";
function Router() {
  return (
    <>
      <Routes>
        <Route path="/" element={<STI />} />
        <Route path="/STI" element={<STI />} />
        <Route path="/VPD1" element={<VPD1 />} />
        <Route path="/VPD2" element={<VPD2 />} />
        <Route path="/WBD" element={<WBD />} />
        <Route path="/OTH1" element={<OTH1 />} />
        <Route path="/OTH2" element={<OTH2 />} />
        <Route path="/HMG" element={<HMG />} />
        <Route path="/FBD" element={<FBD />} />
      </Routes>
    </>
  );
}

export default Router;
